import { Component, Input, OnInit } from '@angular/core';
import { ValueAccessorBase } from '../../shared/value-accessor/value-accessor-base';

/** Translation of key, or fallback when the key has no translation (translate() returns the key). */
export function translatedOr(translations: { translate(key: string): string }, key: string, fallback: string): string {
  const text = translations?.translate(key);
  return text && text !== key ? text : fallback;
}

@Component({
    selector: 'sem-table-presentation',
    templateUrl: './sem-table-presentation.component.html',
    styleUrls: ['./sem-table-presentation.component.css'],
    standalone: false
})
export class SemTablePresentationComponent extends ValueAccessorBase<string> implements OnInit {

  @Input() settings: any = null;
  @Input() result: any = null;

  variable: string = "";
  loadError = false;
  emptyText = "";
  errorText = "";

  super() { }

  ngOnInit(): void {
    this.loadError = false;
    // apps word these per installation (ISPB: "Ni škodnih dogodkov za prikaz.") via translations
    this.emptyText = translatedOr(this.translationsService, "galis_js_table_presentation_empty", "Ni podatkov za prikaz.");
    this.errorText = translatedOr(this.translationsService, "galis_js_table_presentation_error", "Podatkov ni bilo mogoče naložiti.");

    if (this.settings) {
      this.restProviderService.getData(this.settings["ApiUrl"]).subscribe(data => {
        this.result = data;
      },
        error => {
          console.error("sem-table-presentation", error);
          this.loadError = true;
          this.result = [];
        });
    }
  }

}
